// extracted by mini-css-extract-plugin
export var shake = "_1n-0";